import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ toggleSidebar, token, logout }) => {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-dark bg-dark shadow-sm px-3 d-flex justify-content-between align-items-center fixed-top">
      <div className="d-flex align-items-center">
        <button className="btn btn-outline-light me-2" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </button>
        <a className="navbar-brand fw-bold mb-0" href="#">
          لوحة التحكم
        </a>
      </div>

      <div>
        {/* <a className="nav-link text-white d-inline-block mx-2" href="#">
          الإعدادات
        </a> */}

        {token ? (
          // المستخدم مسجل دخول ➜ أظهر "تسجيل الخروج"
          <button
            className="btn btn-link nav-link text-white d-inline-block"
            onClick={() => {
              logout();
              navigate("/login");
            }}>
            تسجيل الخروج
          </button>
        ) : (
          // المستخدم غير مسجل ➜ أظهر "تسجيل الدخول"
          <button
            className="btn btn-link nav-link text-white d-inline-block"
            onClick={() => navigate("/login")}>
            تسجيل الدخول
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
